// extracted by mini-css-extract-plugin
export default {"banner0":"banner0___SKwKd","banner0White":"banner0White___gjuhM","banner0Red":"banner0Red___j5Z3t"};